import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    rules: [],
    currentField: '',
    pastState: [],
    presentState: {},
    futureState: []
}

export const simpleModeSlice = createSlice({
    name: 'simpleMode',
    initialState,
    reducers: {
        updateCurrentField: (state, action) => {
            state.currentField = action.payload;
        },
        updateRules: (state, action) => {
            state.rules = action.payload;
        },
        setState: (state, action) => {
            state.presentState;
        },
        // TODO:
        undoState: (state) => {

        },
        redoState: (state) => {
            state = {
                ...state,
                pastState: [...state.pastState, state.presentState],
                presentState: state.pastState[state.pastState.length - 1],
                futureState: [...state.futureState, state.presentState]
            }
        },
        clearState: (state) => {
            state = { ...state, pastState: [], presentState: [], futureState: [] };
        }
    }
})

export const { updateCurrentField, updateRules } = simpleModeSlice.actions;

export default simpleModeSlice.reducer;